.wrapper { // This keeps the background covering the page even as the user scrolls
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background-color: initial !important;
}

.activityLogBtn {
  background-color: transparent;
  color: var(--ds-759, #0066be);
  cursor: pointer;
  display: inline-block;
  text-decoration-line: underline;
  text-decoration-thickness: 0.0625rem;
  text-underline-offset: 3px;
  margin-left: 1rem;
}

.activityLogModalWrapper >div:first-child {
  align-items: initial;
  margin-top: 3%;

  @media (max-width: 800px) {
    margin-top: 0;
  }
}

.activityLogModalWrapper >div:first-child >div:first-child {
  width: 45%;

  @media (max-width: 800px) {
    width: 100%;
  }
}

.activityLogModalWrapper >div:first-child >div:first-child >div:first-child {
  >header:first-child {
    padding: 0.7rem;
    background-color: initial !important;
  }

  >div:nth-child(2) {
    padding-top: 0.5rem;

    >table:first-child {
      >tbody {
        >tr {
          >td {
            text-align: left !important;
          }
        }
      }
    }
  }

  @media (max-width: 800px) {
    >header:first-child {
      padding: 0.2rem 0.2rem 0.2rem 1rem;

      >h2 {
        font-size: 1.3rem;
      }
    }

    >div:nth-child(2) {
      padding: 0rem 0.3rem 0.3rem 0.3rem;
    }
  }
}